export const gene_name = () =>
  Math.random().toString(36).substring(2, 10).toUpperCase();

let installed = JSON.parse(localStorage.getItem("installed") || "[]");

const apps = [
  {
    name: "Start",
    icon: "home",
    type: "action",
    action: "STARTMENU",
  },
  {
    name: "Search",
    icon: "search",
    type: "action",
    action: "SEARCHMENU",
  },
  {
    name: "Widget",
    icon: "widget",
    type: "action",
    action: "WIDGETS",
  },
  {
    name: "Settings",
    icon: "settings",
    type: "app",
    action: "SETTINGS",
  },
  {
    name: "Task Manager",
    icon: "taskmanager",
    type: "app",
    action: "TASKMANAGER",
  },
  {
    name: "File Explorer",
    icon: "explorer",
    type: "app",
    action: "EXPLORER",
  },
  {
    name: "Browser",
    icon: "fd-browser",
    type: "app",
    action: "FDBROWSER",
  },
  {
    name: "App Catalog",
    icon: "fd-catalog",
    type: "app",
    action: "FDCATALOG",
  },
  {
    name: "Recycle Bin",
    icon: "bin0",
    type: "app",
  },
  {
    name: "Student",
    icon: "win/user",
    type: "app",
    action: "EXPLORER",
  },
  {
    name: "Alarms",
    icon: "alarm",
    type: "app",
  },
  {
    name: "Calculator",
    icon: "calculator",
    type: "app",
    action: "CALCUAPP",
  },
  {
    name: "Calendar",
    icon: "calendar",
    type: "app",
  },
  {
    name: "Camera",
    icon: "camera",
    type: "app",
    action: "CAMERA",
  },
  {
    name: "Phone",
    icon: "fd-phone",
    type: "app",
  },
  {
    name: "Feedback",
    icon: "feedback",
    type: "app",
  },
  {
    name: "Get Started",
    icon: "getstarted",
    type: "app",
    action: "OOBE",
  },
  {
    name: "Media Player",
    icon: "fd-generic",
    type: "app",
  },
  {
    name: "Help",
    icon: "help",
    type: "app",
  },
  {
    name: "Community",
    icon: "share",
    type: "app",
  },
  {
    name: "Mail",
    icon: "mail",
    type: "app",
  },
  {
    name: "Movies",
    icon: "movies",
    type: "app",
  },
  {
    name: "Games",
    icon: "fd-games",
    type: "app",
  },
  {
    name: "Documents",
    icon: "fd-documents",
    type: "app",
  },
  {
    name: "Narrator",
    icon: "narrator",
    type: "app",
  },
  {
    name: "News",
    icon: "news",
    type: "app",
  },
  {
    name: "Notepad",
    icon: "notepad",
    type: "app",
    action: "NOTEPAD",
  },
  {
    name: "Sticky Notes",
    icon: "notes",
    type: "app",
  },
  {
    name: "Cloud Drive",
    icon: "fd-cloud-drive",
    type: "app",
  },
  {
    name: "Notes",
    icon: "fd-notebook",
    type: "app",
  },
  {
    name: "Mail Client",
    icon: "fd-mail-client",
    type: "app",
  },
  {
    name: "People",
    icon: "people",
    type: "app",
  },
  {
    name: "Photos",
    icon: "photos",
    type: "app",
  },
  {
    name: "Pinboard",
    icon: "notes",
    type: "app",
  },
  {
    name: "Security",
    icon: "security",
    type: "app",
  },
  {
    name: "Team Sites",
    icon: "share",
    type: "app",
  },
  {
    name: "Chat",
    icon: "fd-chat",
    type: "app",
  },
  {
    name: "Snipping Tool",
    icon: "snip",
    type: "app",
  },
  {
    name: "Updates",
    icon: "news",
    type: "app",
  },
  {
    name: "Team Chat",
    icon: "fd-team-chat",
    type: "app",
  },
  {
    name: "Terminal",
    icon: "terminal",
    type: "app",
    action: "TERMINAL",
  },
  {
    name: "Tips",
    icon: "tips",
    type: "app",
  },
  {
    name: "To Do",
    icon: "todo",
    type: "app",
  },
  {
    name: "Maps",
    icon: "maps",
    type: "app",
  },
  {
    name: "Voice Recorder",
    icon: "voice",
    type: "app",
  },
  {
    name: "Weather",
    icon: "weather",
    type: "app",
  },
  {
    name: "Whiteboard",
    icon: "board",
    type: "app",
    action: "WHITEBOARD",
  },
  {
    name: "Assistant",
    icon: "fd-assistant",
    type: "app",
  },
  {
    name: "Local Users and Groups",
    icon: "fd-lusrmgr",
    type: "app",
    action: "FD_LUSRMGR",
    fdAppId: "lusrmgr",
  },
  {
    name: "Network Connections",
    icon: "fd-ncpa",
    type: "app",
    action: "FD_NCPA",
    fdAppId: "ncpa",
  },
  {
    name: "System Properties",
    icon: "fd-sysdm",
    type: "app",
    action: "FD_SYSDM",
    fdAppId: "sysdm",
  },
  {
    name: "Server Manager-style Console",
    icon: "fd-servermanager",
    type: "app",
    action: "FD_SERVERMANAGER",
    fdAppId: "server-manager",
  },
];

for (let i = 0; i < installed.length; i++) {
  installed[i].action = gene_name();
  apps.push(installed[i]);
}

export default apps;
